import React from "react";
import { observer } from "mobx-react";

import CashoutConfirmation from "./CashoutConfirmation";
import { useRootAppStore } from "@hooks";

export default observer(function CashoutConfirmationPopUp() {
	const store = useRootAppStore().myBetsViewStore;

	if (store == null) {
		return null;
	}

	if (!store.cashoutStore.isEventCashoutModalOpen) {
		return null;
	}

	if (store.cashoutStore.eventCashoutModalData == null) {
		return null;
	}

	return (
		<CashoutConfirmation
			isOpen={store.cashoutStore.isEventCashoutModalOpen}
			{...store.cashoutStore.eventCashoutModalData}
			onAccept={store.cashoutStore.cashout}
			onClose={store.cashoutStore.closeEventCashoutModal}
			isSubmitting={store.cashoutStore.isCashoutFormSubmitting}
		/>
	);
});
